import React from "react";
import { stockwaveClassNames } from "../../../utils/widgets/stockwave";

/**
 * @param {{isStockwaveEnabled: boolean | undefined}} props `isStockwaveEnabled` <-- `mpConfig.enableStockwave` setting
 */
export const StockwaveLightbulb = ({isStockwaveEnabled}) => {
    if (isStockwaveEnabled !== true) return null;

    return (
        <div className={stockwaveClassNames.lightbulb} />
    )
}